import React from 'react';
import PropTypes from 'prop-types';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { useTranslation } from 'react-i18next';

import { SortableItem } from './SortableItem';

const FileList = ({ files, thumbnails, loadingThumbnails, removeFile, handleOnDragEnd }) => {
  const { t } = useTranslation();
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  return (
    <div className="file-list-container">
      <h3>{t('messages.selectFiles')} ({files.length})</h3>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleOnDragEnd}
      >
        <SortableContext
          items={files.map(f => f.id)}
          strategy={verticalListSortingStrategy}
        >
                    <ul className="file-list">
            {files.map((file) => (
              <SortableItem key={file.id} id={file.id}>
                <button className="remove-btn" onClick={() => removeFile(file.id)} aria-label={`Remove ${file.file.name}`}>&times;</button>
                <div className="file-thumbnail">
                  {loadingThumbnails ? (
                    <div className="thumbnail-loading"><div className="spinner"></div></div>
                  ) : thumbnails[file.id] ? (
                    <img src={thumbnails[file.id]} alt={file.file.name} className="thumbnail" style={{ transform: `rotate(${file.rotation || 0}deg)` }} />
                  ) : (
                    <div className="file-icon"><i className="fas fa-file-pdf fa-3x"></i></div>
                  )}
                </div>
                <div className="file-details">
                  <span className="file-name" title={file.file.name}>{file.file.name}</span>
                  <span className="file-size">{(file.file.size / 1024 / 1024).toFixed(2)} MB</span>
                </div>
              </SortableItem>
            ))}
          </ul>
        </SortableContext>
      </DndContext>
    </div>
  );
};

FileList.propTypes = {
  files: PropTypes.array.isRequired,
  thumbnails: PropTypes.object.isRequired,
  loadingThumbnails: PropTypes.bool.isRequired,
  removeFile: PropTypes.func.isRequired,
  handleOnDragEnd: PropTypes.func.isRequired,
};

export default FileList;
